module.exports = __webpack_public_path__ + "static/media/Theon Greyjoy 2.ffdc4f01.jpg";